export default {
  firstName: 'First name',
  lastName: 'Last name',
  middleName: 'Middle name',
}
